// Import components
import React, { useMemo, useState } from "react";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { Modal, Label, ModalHeader, Card, CardBody, Row, Col, Alert, UncontrolledTooltip } from 'reactstrap';
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png";
import axios from "axios";
import { useEffect } from "react";
import { Link } from "react-router-dom";

interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}

const AdminAssignments = () => {
    const isAdmin = localStorage.getItem("userole_") === "adm";

    const [addAssignmentModal, setAddAssignmentModal] = useState(false);
    const [deleteAssignmentModal, setDeleteAssignmentModal] = useState(false);

    const [assignmentsData, setAssignmentData] = useState<any[]>([]);
    const [partnersList, setPartnersList] = useState<any[]>([]);
    const [employeesList, setEmployeesList] = useState<any[]>([]);
    const [clientsList, setClientsList] = useState<any[]>([]);
    const [domainsList, setDomainsList] = useState<any[]>([]);

    const assignmentInitialDetails = {
        client: "",
        assignee_type: "",
        assignee_id: "",
        assignee_model: "",
        domain: "",
    };
    const [assignmentDetails, setAssignmentDetails] = useState<any>(assignmentInitialDetails);

    const [showloader, setshowloader] = useState(true);
    const [alertMsgg, setAlertMsgg] = useState<any>({ open: false, type: "success", content: "Messages here.", time: "2500" });

    const handleAlertMsggClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false });
    };

    // Helper function to render tools with tooltip
    const renderToolsWithTooltip = (tools: string[], domainName: string, uniqueId: string) => {
        if (!tools || tools.length === 0) return null;
        
        return (
            <>
                <i 
                    className="bx bx-info-circle text-primary ms-2" 
                    id={`tools-tooltip-${uniqueId}`}
                    style={{ cursor: 'pointer', fontSize: '16px' }}
                ></i>
                <UncontrolledTooltip
                    placement="top"
                    target={`tools-tooltip-${uniqueId}`}
                >
                    <div className="text-start">
                        <strong>{domainName} Tools:</strong>
                        <ul className="mb-0 ps-3">
                            {tools.map((tool, idx) => (
                                <li key={idx}>{tool}</li>
                            ))}
                        </ul>
                    </div>
                </UncontrolledTooltip>
            </>
        );
    };

    const fetch_assignments = async () => {
        try {
            setshowloader(true);
            const response = await axios.get(
                `/assignments/listAssignments`,
                {},
                { withCredentials: true }
            );
            if (response && response.status === "SENT") {
                setAssignmentData(response.assignments || []);
            }
            setshowloader(false);
        } catch (error: any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout"; }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }
    };

    const fetch_Data = async () => {
        try {
            setshowloader(true);
            const response = await axios.get(
                `/accounts/partners-and-employees`,
                {},
                { withCredentials: true }
            );

            if (response && response.status === 'SENT') {

                setPartnersList(response.partners || []);
                setEmployeesList(response.employees || []);
            }
            setshowloader(false);
        } catch (error: any) {
            console.log("Error fetching partners and employees:", error);

            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout"; }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }

        try {
            setshowloader(true);
            const response = await axios.get(
                `/accounts/getdomains`,
                {},
                { withCredentials: true }
            );

            if (response && response.status === 'SENT') {

                setDomainsList(response.domains || []);
            }
            setshowloader(false);
        } catch (error: any) {
            console.log("Error fetching partners and employees:", error);

            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout"; }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }

        try {
            setshowloader(true);
            const response = await axios.get(
                `/accounts/listClients`,
                {},
                { withCredentials: true }
            );

            if (response && response.status === 'SENT') {

                setClientsList(response.clients || []);
            }
            setshowloader(false);
        } catch (error: any) {
            console.log("Error fetching partners and employees:", error);

            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout"; }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }
    };

    useEffect(() => {
        if (!isAdmin) {
            setshowloader(false);
            return;
        }
        fetch_assignments();
        fetch_Data();
    }, [isAdmin]);

    function toggleDeleteModal() {
        setDeleteAssignmentModal(!deleteAssignmentModal);
        removeBodyCss();
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    const toggleAddUpdateModal = () => {
        setAddAssignmentModal(!addAssignmentModal);
        removeBodyCss();
    }

    const assigneeTypeReverseMap: Record<string, { type: string; model: string }> = {
        prt: { type: "partner", model: "prtprofile" },
        emp: { type: "employee", model: "empprofile" }
    };

    const manageAssignment = async (operation: "create" | "update" | "delete" = "create") => {
        // For create/update, ensure required fields are present
        if (
            (operation === "create" || operation === "update") &&
            (!assignmentDetails.client || !assignmentDetails.domain || !assignmentDetails.assignee_id)
        ) {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Please select all fields.", type: "error" });
            return;
        }

        // For delete/update, ensure assignment id is present
        if ((operation === "delete" || operation === "update") && !assignmentDetails?.id) {
            setAlertMsgg({ ...alertMsgg, open: true, content: "No assignment selected.", type: "error" });
            return;
        }

        const assigneeTypeMap: Record<string, { type: string; model: string }> = {
            partner: { type: "prt", model: "prtprofile" },
            employee: { type: "emp", model: "empprofile" }
        };

        const assigneeType = assigneeTypeMap[assignmentDetails.assignee_type];

        // Prepare payload
        let payload: any = {};
        if (operation === "create") {
            payload = {
                client: assignmentDetails.client,
                assignee_type: assigneeType.type,
                assignee_id: assignmentDetails.assignee_id,
                assignee_model: assigneeType.model,
                domain: assignmentDetails.domain
            };
        } else if (operation === "update") {
            payload = {
                assignment_id: assignmentDetails.id,
                client: assignmentDetails.client,
                assignee_type: assigneeType.type,
                assignee_id: assignmentDetails.assignee_id,
                assignee_model: assigneeType.model,
                domain: assignmentDetails.domain
            };
        } else if (operation === "delete") {
            payload = {
                assignment_id: assignmentDetails.id,
                todelete: true
            };
        }

        try {
            setshowloader(true);
            const response = await axios.post(
                "/assignments/manageAssignment/",
                payload,
                { withCredentials: true }
            );
            if (
                response &&
                (response.status === "CREATED" ||
                    response.status === "UPDATED" ||
                    response.status === "DELETED")
            ) {
                let msg = "Assignment ";
                if (operation === "create") msg += "created";
                else if (operation === "update") msg += "updated";
                else if (operation === "delete") msg += "deleted";
                msg += " successfully.";
                setAlertMsgg({ ...alertMsgg, open: true, content: msg, type: "success" });
                fetch_assignments();
                setAssignmentDetails(assignmentInitialDetails);
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: `Failed to ${operation} assignment.`, type: "error" });
            }
            setshowloader(false);
        } catch (error: any) {
            if (error.response) {
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }
    }

    const columns: column[] = useMemo(
        () => [
            {
                header: 'S.No',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => row.index + 1,
            },
            {
                header: 'Client',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {
                    const client = row.original.client;

                    return (
                        <div className="d-flex align-items-center">
                            <div>
                                <div className="fw-medium text-capitalize">{client.name}</div>
                                <div className="font-size-12">{client.email}</div>
                            </div>
                        </div>
                    );
                },
            },
            {
                header: 'Partner/Employee',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {

                    const assignee = row.original.assignee;
                    const domain = row.original.domain;
                    const isBookkeepingDomain = domain?.name?.toLowerCase().includes('bookkeeping');
                    const isTaxDomain = domain?.name?.toLowerCase().includes('tax');
                    
                    let toolsToDisplay: string[] = [];
                    let domainType = '';
                    
                    if (isBookkeepingDomain && assignee.bookkeeping_tools && assignee.bookkeeping_tools.length > 0) {
                        toolsToDisplay = assignee.bookkeeping_tools;
                        domainType = 'Bookkeeping';
                    } else if (isTaxDomain && assignee.tax_tools && assignee.tax_tools.length > 0) {
                        toolsToDisplay = assignee.tax_tools;
                        domainType = 'Tax';
                    }

                    return (
                        <div className="d-flex align-items-center">
                            <div>
                                <div className="fw-medium text-capitalize">
                                    {assignee.name}
                                    {toolsToDisplay.length > 0 && renderToolsWithTooltip(toolsToDisplay, domainType, `table-${row.original.id}`)}
                                </div>
                                <div className="font-size-12">{assignee.email}</div>
                            </div>
                        </div>
                    );
                },
            },
            {
                header: 'Domain',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => <div className="fw-medium text-capitalize">{row.original.domain.name}</div>,
            },
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {

                    return (
                        <div className="d-flex gap-2">
                            <button
                                className="btn btn-dark btn-sm"
                                title="Click to Edit"
                                onClick={() => {
                                    setAssignmentDetails({
                                        client: row.original.client.id,
                                        assignee_type: assigneeTypeReverseMap[row.original.assignee_type].type,
                                        assignee_id: row.original.assignee.id,
                                        assignee_model: assigneeTypeReverseMap[row.original.assignee_type].model,
                                        domain: row.original.domain.id,
                                        id: row.original.id,
                                    });
                                    toggleAddUpdateModal();
                                }}
                            >
                                <i className="bx bx-pencil me-1"></i>
                                Edit
                            </button>
                            <button
                                className="btn btn-danger btn-sm"
                                title="Click to Delete"
                                onClick={() => {
                                    setAssignmentDetails(row.original);
                                    setDeleteAssignmentModal(true);
                                }}
                            >
                                <i className="bx bxs-trash-alt me-1"></i>
                                Delete
                            </button>
                            <Link to={`/adminTasks?assignment_id=${row.original.id}`} className="btn btn-primary  btn-sm">
                                <i className="bx bx-task me-1"></i>
                                Manage Tasks
                            </Link>
                        </div>
                    );
                },
            }
        ],
        []
    );

    document.title = "Assignments | BizServe";

    if (!isAdmin) {
        return (
            <div className="page-content">
                <div className="container-fluid">
                    <Card className="mt-4">
                        <CardBody>
                            <Alert color="danger" className="mb-3">
                                You do not have permission to view this page.
                            </Alert>
                            <Link to="/" className="btn btn-primary">
                                Go to home
                            </Link>
                        </CardBody>
                    </Card>
                </div>
            </div>
        );
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title="Admin" breadcrumbItem="Assignments" />
                {alertMsgg.open && (
                    <Alert
                        color={alertMsgg.type === "success" ? "success" : "danger"}
                        toggle={handleAlertMsggClose}
                        fade={false}
                        style={{ fontWeight: "bold" }}
                    >
                        {alertMsgg.content}
                    </Alert>
                )}
                <div className="loaderContainer" hidden={!showloader}>
                    <div className="spinner">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <Row>
                    <Col md={12} className="d-flex justify-content-end align-items-center mb-3">
                        <button
                            type="button"
                            className="btn btn-primary "
                            onClick={() => {
                                setAssignmentDetails(assignmentInitialDetails);
                                toggleAddUpdateModal();
                            }}
                        >
                            Add Assignment
                        </button>
                    </Col>
                    <Col md={12}>
                        <Card className="rounded-4 border">
                            <CardBody>
                                <TableContainer
                                    columns={columns}
                                    data={assignmentsData}
                                    isGlobalFilter={true}
                                    isPagination={true}
                                    SearchPlaceholder="Search By Name..."
                                    pagination="pagination"
                                    paginationWrapper='dataTables_paginate paging_simple_numbers'
                                    tableClass="table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {/* Add Assisgnment */}
                <Modal
                    isOpen={addAssignmentModal}
                    size="lg"
                    toggle={() => {
                        toggleAddUpdateModal();
                    }}
                    backdrop={'static'}
                    centered
                >
                    <ModalHeader>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                            {assignmentDetails?.id ? "Edit Assignment" : "Add Assignment"}
                        </div>
                    </ModalHeader>
                    <div className="modal-body">
                        <form>
                            <Row>
                                <Col lg={6}>
                                    <div className="mb-3">
                                        <label className="form-label">Client</label>
                                        <select
                                            className="form-control text-capitalize"
                                            value={assignmentDetails.client || ""}
                                            onChange={e => {
                                                const client = clientsList.find(c => String(c.id) === e.target.value);
                                                setAssignmentDetails({ ...assignmentDetails, client: client ? client.id : "" });
                                            }}
                                            disabled={!!assignmentDetails?.id}
                                        >
                                            <option value="">Select Client</option>
                                            {clientsList.map((client: any) => (
                                                <option key={client.id} value={client.id}>
                                                    {client.user.get_full_name} ({client.user.email})
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className="mb-3">
                                        <label className="form-label">Domain</label>
                                        <select
                                            className="form-control text-capitalize"
                                            value={assignmentDetails.domain || ""}
                                            onChange={e => {
                                                const domain = domainsList.find(d => String(d.id) === e.target.value);
                                                setAssignmentDetails({ ...assignmentDetails, domain: domain ? domain.id : "" });
                                            }}
                                            disabled={!!assignmentDetails?.id}
                                        >
                                            <option value="">Select Domain</option>
                                            {domainsList.map((domain: any) => (
                                                <option key={domain.id} value={domain.id}>{domain.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="mb-3">
                                        <label className="form-label me-3">Assign To:</label>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="partnerOrEmployee"
                                                id="radio-partner"
                                                value="partner"
                                                checked={assignmentDetails.assignee_type === 'partner'}
                                                onChange={() => setAssignmentDetails({ ...assignmentDetails, assignee_type: 'partner', assignee_id: "" })}
                                            // disabled={!!assignmentDetails?.id}
                                            />
                                            <label className="form-check-label" htmlFor="radio-partner">Partner</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="partnerOrEmployee"
                                                id="radio-employee"
                                                value="employee"
                                                checked={assignmentDetails.assignee_type === 'employee'}
                                                onChange={() => setAssignmentDetails({ ...assignmentDetails, assignee_type: 'employee', assignee_id: "" })}
                                            // disabled={!!assignmentDetails?.id}
                                            />
                                            <label className="form-check-label" htmlFor="radio-employee">Employee</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="mb-3">
                                        <label className="form-label">
                                            {assignmentDetails.assignee_type === 'partner' ? 'Partner' : 'Employee'}
                                        </label>
                                        <select
                                            className="form-control text-capitalize"
                                            value={assignmentDetails.assignee_id || ""}
                                            onChange={e => {
                                                const list = assignmentDetails.assignee_type === 'partner' ? partnersList : employeesList;
                                                const selected = list.find((item: any) => String(item.id) === e.target.value);
                                                setAssignmentDetails({ ...assignmentDetails, assignee_id: selected ? selected.id : "" });
                                            }}
                                            disabled={assignmentDetails?.assignee_type === ""}
                                        >
                                            <option value="">Select {assignmentDetails.assignee_type === 'partner' ? 'Partner' : 'Employee'}</option>
                                            {(assignmentDetails.assignee_type === 'partner' ? partnersList : employeesList).map((item: any) => {
                                                if (assignmentDetails.domain && item.domains.includes(Number(assignmentDetails.domain))) {
                                                    const selectedDomain = domainsList.find(d => d.id === Number(assignmentDetails.domain));
                                                    const isBookkeepingDomain = selectedDomain?.name?.toLowerCase().includes('bookkeeping');
                                                    const isTaxDomain = selectedDomain?.name?.toLowerCase().includes('tax');
                                                    
                                                    let toolsText = '';
                                                    if (isBookkeepingDomain && item.bookkeeping_tools && item.bookkeeping_tools.length > 0) {
                                                        toolsText = ` [${item.bookkeeping_tools.join(', ')}]`;
                                                    } else if (isTaxDomain && item.tax_tools && item.tax_tools.length > 0) {
                                                        toolsText = ` [${item.tax_tools.join(', ')}]`;
                                                    }
                                                    
                                                    return (<option key={item.id} value={String(item.id)}>{item.user.get_full_name}{toolsText}</option>)
                                                }
                                            })}
                                        </select>
                                        {assignmentDetails.assignee_id && (() => {
                                            const list = assignmentDetails.assignee_type === 'partner' ? partnersList : employeesList;
                                            const selected = list.find((item: any) => String(item.id) === String(assignmentDetails.assignee_id));
                                            const selectedDomain = domainsList.find(d => d.id === Number(assignmentDetails.domain));
                                            const isBookkeepingDomain = selectedDomain?.name?.toLowerCase().includes('bookkeeping');
                                            const isTaxDomain = selectedDomain?.name?.toLowerCase().includes('tax');
                                            
                                            let toolsToDisplay: string[] = [];
                                            let domainType = '';
                                            
                                            if (selected) {
                                                if (isBookkeepingDomain && selected.bookkeeping_tools && selected.bookkeeping_tools.length > 0) {
                                                    toolsToDisplay = selected.bookkeeping_tools;
                                                    domainType = 'Bookkeeping';
                                                } else if (isTaxDomain && selected.tax_tools && selected.tax_tools.length > 0) {
                                                    toolsToDisplay = selected.tax_tools;
                                                    domainType = 'Tax';
                                                }
                                            }
                                            return null;
                                        })()}
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="d-flex justify-content-end gap-2">
                                        <button
                                            className="btn btn-danger mb-3"
                                            type="button"
                                            onClick={() => toggleAddUpdateModal()}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-primary mb-3"
                                            type="button"
                                            onClick={() => { manageAssignment(assignmentDetails?.id ? "update" : "create"); toggleAddUpdateModal(); }}
                                        >
                                            {assignmentDetails?.id ? "Update Assignment" : "Add Assignment"}
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </Modal>
                {/* Delete Assisgnment */}
                <Modal
                    isOpen={deleteAssignmentModal}
                    toggle={() => {
                        toggleDeleteModal();
                    }}
                    centered
                    className="rounded-4"
                >
                    <ModalHeader className="py-3 px-4" toggle={() => { toggleDeleteModal(); }}>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                            Delete Assignment
                        </div>
                    </ModalHeader>

                    <div className="modal-body">
                        <p>Are you sure you want to delete this assignment?</p>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-sm btn-soft-dark"
                            onClick={() => { toggleDeleteModal(); }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                                manageAssignment("delete");
                                toggleDeleteModal();
                            }}
                        >
                            Delete
                        </button>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

export default AdminAssignments;
